import { render } from "./SubscribeBenefitsTable.vue?vue&type=template&id=7d17c67f"
import script from "./SubscribeBenefitsTable.vue?vue&type=script&lang=js"
export * from "./SubscribeBenefitsTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__